var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetProcessing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Fleet_Processing"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fleet_Processing",
    "data-name": "Fleet Processing",
    clipPath: "url(#clip-Fleet_Processing)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9718",
    "data-name": "Group 9718",
    transform: "translate(2.162 2.162)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_432",
    "data-name": "Ellipse 432",
    cx: 11.838,
    cy: 11.838,
    r: 11.838,
    fill: "#abe0e2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M6.224,0A6.23,6.23,0,0,0,0,6.223H6.224v6.223A6.223,6.223,0,0,0,6.224,0Z",
    transform: "translate(20.223 20.223) rotate(180)",
    fill: "#1e888b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetProcessing);
export default __webpack_public_path__ + "static/media/Fleet Processing.2c72b090476521f96de5acf3bdb421f0.svg";
export { ForwardRef as ReactComponent };